const colors = {
  0: 'red',
  1: 'orange',
  2: 'green',
  3: 'blue',
};
export default colors;
